import { Component, Inject, OnInit } from "@angular/core";
import { BvDialogService, BV_DIALOG_DATA } from "../../design-system";
import { AuthService } from "src/app/providers/auth.service";
import { ProfileService } from "src/app/providers/profile.service";
import { LoadingOverlayComponent } from "../../shared/loading-overlay/loading-overlay.component";
import { BvDialogTitleComponent, BvDialogBodyComponent, BvDialogFooterComponent } from "../../design-system/primitives/dialog.component";
import { BvFormFieldComponent } from "../../design-system/primitives/form-field.component";
import { BvInputDirective } from "../../design-system/primitives/input.directive";
import { FormsModule } from "@angular/forms";
import { CloseDialogButtonComponent } from "../../shared/close-dialog-button/close-dialog-button.component";
import { BvButtonComponent } from "../../design-system/primitives/button.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-reset-email",
    templateUrl: "./reset-email.component.html",
    styleUrls: ["./reset-email.component.css"],
    imports: [LoadingOverlayComponent, BvDialogTitleComponent, BvDialogBodyComponent, BvFormFieldComponent, BvInputDirective, FormsModule, BvDialogFooterComponent, CloseDialogButtonComponent, BvButtonComponent, TranslateModule]
})
export class ResetEmailComponent implements OnInit {
  email!: string;
  password: string = "";
  isWrongPassword: boolean = false;
  isUserAlreadyExists: boolean = false;
  newEmail: boolean = false;

  constructor(
    @Inject(BV_DIALOG_DATA) public data: string,
    public profServ: ProfileService,
    public auth: AuthService,
    private dialog: BvDialogService
  ) {}

  ngOnInit(): void {
    this.email = this.data;
    this.password = "";
  }

  resetEmail() {
    this.newEmail = true;
    if (this.email != this.auth.userInfo.email) {
      this.auth
        .updateEmailAddress(this.email, this.password)
        .then((res: any) => {
          if (
            res.code === "auth/wrong-password" ||
            res === "auth/email-already-in-use"
          ) {
            if (res.code === "auth/wrong-password") {
              this.isWrongPassword = true;
              this.newEmail = false;
            } else this.isWrongPassword = false;

            if (res === "auth/email-already-in-use") {
              this.isUserAlreadyExists = true;
              this.newEmail = false;
            } else this.isUserAlreadyExists = false;
          } else {
            this.auth.userInfo.email = this.email;
            this.profServ.updateEmail(this.email);
            this.auth.userInfo.email = this.email;
            this.dialog.closeAll();
            this.newEmail = false;
          }
        });
    } else this.newEmail = false;
  }
}
